type CountryCode = string;

export const useCountriesStore = defineStore("possibleCountries", () => {
  const i18n = useI18n();
  const { locales, locale, t } = i18n;

  const country = computed(() => {
    const currentLocale = locales.value.find((l) => l.code === locale.value);
    return currentLocale?.country ?? "";
  });
  const countryCode = ref<CountryCode>(country.value);

  const currentCountry = computed(() => ({
    code: countryCode.value,
    value: t(countryCode.value),
  }));

  function setCountry(newCountryCode: CountryCode) {
    countryCode.value = newCountryCode;
  }

  watch(country, (newLocale) => {
    if (newLocale !== countryCode.value) {
      countryCode.value = newLocale;
    }
  });

  return { setCountry, currentCountry };
});
